var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPercent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.21466 0.5C5.61547 0.5 6.6783 0.953031 7.40314 1.85909C8.12798 2.76516 8.4904 4.03742 8.4904 5.67588C8.4904 7.31435 8.14834 8.59416 7.46422 9.51532C6.7801 10.4365 5.69692 10.8971 4.21466 10.8971C2.83828 10.8971 1.79174 10.4365 1.07504 9.51532C0.358348 8.59416 0 7.31435 0 5.67588C0 4.03742 0.333915 2.76516 1.00175 1.85909C1.67772 0.953031 2.74869 0.5 4.21466 0.5ZM4.23909 2.86709C3.84002 2.86709 3.54683 3.10115 3.35951 3.56929C3.17219 4.03742 3.07853 4.74717 3.07853 5.69853C3.07853 6.6499 3.17219 7.36342 3.35951 7.83911C3.54683 8.31479 3.84002 8.55263 4.23909 8.55263C4.63816 8.55263 4.93136 8.31857 5.11867 7.85043C5.31414 7.37475 5.41187 6.65745 5.41187 5.69853C5.41187 4.74717 5.31414 4.03742 5.11867 3.56929C4.93136 3.10115 4.63816 2.86709 4.23909 2.86709ZM16.8953 0.737841L6.98778 17.2961H4.05585L13.9634 0.737841H16.8953ZM16.7243 7.11426C18.1251 7.11426 19.1879 7.56729 19.9127 8.47335C20.6376 9.37941 21 10.6517 21 12.2901C21 13.9211 20.6579 15.1971 19.9738 16.1183C19.2897 17.0394 18.2065 17.5 16.7243 17.5C15.3479 17.5 14.3013 17.0394 13.5846 16.1183C12.8679 15.1971 12.5096 13.9211 12.5096 12.2901C12.5096 10.6517 12.8435 9.37941 13.5113 8.47335C14.1873 7.56729 15.2583 7.11426 16.7243 7.11426ZM16.7487 9.48135C16.3496 9.48135 16.0564 9.71541 15.8691 10.1835C15.6818 10.6517 15.5881 11.3614 15.5881 12.3128C15.5881 13.2642 15.6818 13.9777 15.8691 14.4534C16.0564 14.929 16.3496 15.1669 16.7487 15.1669C17.1478 15.1669 17.441 14.9328 17.6283 14.4647C17.8237 13.989 17.9215 13.2717 17.9215 12.3128C17.9215 11.3614 17.8237 10.6517 17.6283 10.1835C17.441 9.71541 17.1478 9.48135 16.7487 9.48135Z",
    fill: "url(#paint0_linear_1_277)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_277",
    x1: 10.5,
    y1: 0.5,
    x2: 10.5,
    y2: 17.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3FF76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464015,
    stopColor: "#72F138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BBD1B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercent);
export default __webpack_public_path__ + "static/media/percent.30eceb19b19305d4df42bbc3ef4ace47.svg";
export { ForwardRef as ReactComponent };